(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/services.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/services.js');
"use strict";

const getSpecificDrawName = svs.utils.products.getSpecificDrawName;
const jupiter = svs.core.jupiter;
const signIndexToOutcome = svs.components.sport.tipsenShared.signIndexToOutcome;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const SportPixWagerSystemTypes = svs.components.tipsen.engine.constants.SportPixWagerSystemTypes;
const selectEngineDefinitionByProductId = svs.components.tipsen.engine.selectors.selectEngineDefinitionByProductId;
const SportPixFlavour = {
  Balanced: 'Balanced',
  Safe: 'Safe'
};
const normalizeRow = (event, eventTypeId) => {
  const signsForEventType = Object.values(signIndexToOutcome[eventTypeId]);
  const signsForEventTypeLength = signsForEventType.length;
  const row = new Array(signsForEventTypeLength).fill(false);
  signsForEventType.forEach((sign, signIndex) => {
    const foundSign = Boolean(event.outcomes.find(el => el.value === sign));
    row[signIndex] = foundSign;
  });
  return row;
};
const normalizeBoard = (pix, board, eventTypeId) => {
  pix.events.forEach(event => {
    const eventIndex = event.eventNumber - 1;
    const row = normalizeRow(event, eventTypeId);
    board[eventIndex] = row;
  });
  return board;
};
const normalizeResponse = (res, systemType, eventTypeId) => {
  const boards = [];
  if (systemType === SportPixWagerSystemTypes.SROW) {
    res.pixes.forEach(pix => {
      let board = new Array(res.pixes[0].events.length).fill(null);
      board = normalizeBoard(pix, board, eventTypeId);
      boards.push(board);
    });
  } else {
    let board = new Array(res.pix.events.length).fill(null);
    board = normalizeBoard(res.pix, board, eventTypeId);
    boards.push(board);
  }
  return boards;
};

const generateSportPixService = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    _ref$flavour = _ref.flavour,
    flavour = _ref$flavour === void 0 ? SportPixFlavour.Safe : _ref$flavour,
    skewPercentage = _ref.skewPercentage,
    size = _ref.size,
    _ref$guaranteedEvents = _ref.guaranteedEvents,
    guaranteedEvents = _ref$guaranteedEvents === void 0 ? {
      events: []
    } : _ref$guaranteedEvents,
    _ref$systemType = _ref.systemType,
    systemType = _ref$systemType === void 0 ? SportPixWagerSystemTypes.XPERT_WAGER_MSYS : _ref$systemType,
    numRows = _ref.numRows;
  return new Promise((resolve, reject) => {
    var _definition$outcomes$;
    if (!productId) {
      throw new Error('productId is required');
    }
    if (!drawNumber) {
      throw new Error('drawNumber is required');
    }
    if (!size) {
      throw new Error('size is required');
    }
    const definition = selectEngineDefinitionByProductId(productId);
    const productDrawName = getSpecificDrawName(productId);
    const path = "/wager/1/".concat(productDrawName, "/pix").concat(systemType === SportPixWagerSystemTypes.SROW ? '/singlerows' : '');
    const pixType = definition.pixType;
    const flavourValue = "".concat(flavour).concat(pixType);
    const params = new URLSearchParams();
    params.append('drawNumber', drawNumber);
    params.append('flavour', flavourValue);
    params.append('systemNumberMapping', size);
    if (systemType !== SportPixWagerSystemTypes.SROW) {
      params.append('systemType', systemType);
    } else {
      params.append('numRows', numRows);
    }
    if (skewPercentage) {
      const minSkewPercentage = 0;
      const maxSkewPercentage = 100;
      params.append('skewPercentage', Math.min(Math.max(parseInt(skewPercentage, 10), minSkewPercentage), maxSkewPercentage));
    }
    const eventTypeId = (_definition$outcomes$ = definition === null || definition === void 0 ? void 0 : definition.outcomes.eventTypeId) !== null && _definition$outcomes$ !== void 0 ? _definition$outcomes$ : EventTypeId.EVENT_1X2;
    jupiter.post({
      path: "".concat(path, "?").concat(params.toString()),
      data: guaranteedEvents
    }, res => {
      const normalizedResponse = normalizeResponse(res, systemType, eventTypeId);
      resolve(normalizedResponse);
    }, error => {
      reject(error.responseJSON.error);
    });
  });
};
setGlobal('svs.components.tipsen.engine.services', {
  generateSportPixService
});

 })(window);